import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Youtube, Mail, Phone, MapPin, ExternalLink, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer id="contact" className="bg-black border-t border-zinc-800">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_bim-solutions-1/artifacts/59918j4p_AJ%20LOGO%20PRETA%20-%20BIMPORTAL.PNG"
              alt="AJ Academy"
              className="h-12 mb-4"
            />
            <p className="text-gray-400 text-sm">Soluções BIM completas para profissionais e estudantes.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="#courses" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Cursos</a></li>
              <li><a href="#consulting" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Consultoria</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Serviços</a></li>
              <li><a href="#bimtalks" className="text-gray-400 hover:text-red-500 transition-colors text-sm">BIMTALKS</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <Mail size={16} className="text-red-500 mt-0.5" />
                <span>contato@bimportal.com.br</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <Phone size={16} className="text-red-500 mt-0.5" />
                <span>(61) 99579-2667</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <MapPin size={16} className="text-red-500 mt-0.5" />
                <span>Brasil</span>
              </li>
            </ul>
          </div>

          {/* Alexander Justi */}
          <div>
            <h4 className="text-white font-semibold mb-4">Sobre o Fundador</h4>
            <p className="text-gray-400 text-sm mb-4">
              Conheça Alexander Justi, profissional responsável pela Plataforma AJ BIM.
            </p>
            <Button
              onClick={() => window.open('https://www.alexjusti.com', '_blank')}
              variant="outline"
              size="sm"
              className="border-red-500 text-red-500 hover:bg-red-500/10"
            >
              Visitar Site
              <ExternalLink className="ml-2" size={14} />
            </Button>
          </div>
        </div>

        {/* Social Links */}
        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2026 AJ|BIMPORTAL. Todos os direitos reservados. (Versão 1.0 - Julho/26)
          </p>
          <div className="flex items-center space-x-4">
            <a
              href="https://www.youtube.com/@Bimtalks"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-500 transition-colors"
            >
              <Youtube size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;